/**
 * Mock itinerary data for Phase 1 of the ItineraryExplorer page.
 * Matches the final backend ItineraryExploreSummaryDTO contract exactly.
 * 6 diverse itineraries across different regions with real lat/lng.
 */

const mockItineraries = [
  {
    id: 1,
    slug: '7-day-cultural-tour-kyoto-1',
    title: 'Kyoto & the Alps: Cultural Dive',
    imageUrl: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800&q=80',
    cost: 1200,
    currency: 'USD',
    days: 7,
    highlights: ['Temples', 'Local Cuisine', 'Nature', 'Hot Springs'],
    creator: { name: 'KanjiT', avatarUrl: 'https://i.pravatar.cc/150?u=kanjit' },
    saveCount: 42,
    isFavorited: true,
    rating: 4.9,
    reviewCount: 128,
    style: 'cultural',
    region: 'Asia',
    country: 'Japan',
    mapPosition: { lat: 35.0116, lng: 135.7681 },
    createdAt: '2026-02-20T10:30:00',
  },
  {
    id: 2,
    slug: '10-day-culinary-journey-tuscany-2',
    title: 'Tuscan Culinary Journey',
    imageUrl: 'https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=800&q=80',
    cost: 1800,
    currency: 'USD',
    days: 10,
    highlights: ['Vineyards', 'Historic Cities', 'Cooking Classes'],
    creator: { name: 'MariaS', avatarUrl: 'https://i.pravatar.cc/150?u=marias' },
    saveCount: 31,
    isFavorited: false,
    rating: 4.7,
    reviewCount: 89,
    style: 'culinary',
    region: 'Europe',
    country: 'Italy',
    mapPosition: { lat: 43.7696, lng: 11.2558 },
    createdAt: '2026-02-18T14:00:00',
  },
  {
    id: 3,
    slug: '12-day-adventure-loop-iceland-3',
    title: 'Icelandic Adventure Loop',
    imageUrl: 'https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=800&q=80',
    cost: 2500,
    currency: 'USD',
    days: 12,
    highlights: ['Glaciers', 'Waterfalls', 'Northern Lights'],
    creator: { name: 'JonE', avatarUrl: 'https://i.pravatar.cc/150?u=jone' },
    saveCount: 27,
    isFavorited: false,
    rating: 4.8,
    reviewCount: 64,
    style: 'adventure',
    region: 'Europe',
    country: 'Iceland',
    mapPosition: { lat: 64.9631, lng: -19.0208 },
    createdAt: '2026-02-15T09:00:00',
  },
  {
    id: 4,
    slug: '14-day-andes-expedition-peru-4',
    title: 'Peruvian Andes Expedition',
    imageUrl: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=800&q=80',
    cost: 1500,
    currency: 'USD',
    days: 14,
    highlights: ['Trekking', 'Machu Picchu', 'Local Culture'],
    creator: { name: 'SofiaA', avatarUrl: 'https://i.pravatar.cc/150?u=sofiaa' },
    saveCount: 19,
    isFavorited: false,
    rating: 4.7,
    reviewCount: 52,
    style: 'adventure',
    region: 'Americas',
    country: 'Peru',
    mapPosition: { lat: -13.1631, lng: -72.5450 },
    createdAt: '2026-02-10T11:00:00',
  },
  {
    id: 5,
    slug: '8-day-desert-medinas-morocco-5',
    title: 'Moroccan Desert & Medinas',
    imageUrl: null,
    cost: 950,
    currency: 'USD',
    days: 8,
    highlights: ['Sahara Camping', 'Souks', 'Riads', 'Atlas Mountains'],
    creator: { name: 'Safar AI', avatarUrl: null },
    saveCount: 15,
    isFavorited: false,
    rating: null,
    reviewCount: 0,
    style: 'cultural',
    region: 'Africa',
    country: 'Morocco',
    mapPosition: { lat: 31.6295, lng: -7.9811 },
    createdAt: '2026-02-25T08:00:00',
  },
  {
    id: 6,
    slug: '10-day-pacific-coast-highway-usa-6',
    title: 'Pacific Coast Highway Road Trip',
    imageUrl: 'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?w=800&q=80',
    cost: 2200,
    currency: 'USD',
    days: 10,
    highlights: ['Coastal Drives', 'National Parks', 'Wine Country', 'Beaches'],
    creator: { name: 'MikeR', avatarUrl: 'https://i.pravatar.cc/150?u=miker' },
    saveCount: 38,
    isFavorited: false,
    rating: 4.5,
    reviewCount: 73,
    style: 'nature',
    region: 'Americas',
    country: 'USA',
    mapPosition: { lat: 36.2704, lng: -121.8081 },
    createdAt: '2026-02-12T16:00:00',
  },
];

/**
 * Region cluster data for the map — aggregated counts by region.
 * In Phase 2, this comes from the API response `regions` array.
 */
export const regionClusters = [
  { name: 'Europe', count: 12, lat: 48.0, lng: 10.0 },
  { name: 'Americas', count: 8, lat: 40.71, lng: -74.01 },
  { name: 'Africa', count: 3, lat: 6.52, lng: 3.38 },
];

export default mockItineraries;
